import { render } from "./Standard.vue?vue&type=template&id=5c110a2c&scoped=true&ts=true"
import script from "./Standard.vue?vue&type=script&lang=ts"
export * from "./Standard.vue?vue&type=script&lang=ts"

import "./Standard.vue?vue&type=style&index=0&id=5c110a2c&scoped=true&lang=css"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c110a2c"]])

export default __exports__